import { render, staticRenderFns } from "./CommunityAbuseForm.vue?vue&type=template&id=8bf12430&"
import script from "./CommunityAbuseForm.vue?vue&type=script&lang=js&"
export * from "./CommunityAbuseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports